// pages/ForbiddenPage.jsx
import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { LockOutlined } from "@ant-design/icons";

const ForbiddenPage = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="403"
      title="403 - Ruxsat yo'q"
      subTitle="Kechirasiz, bu sahifaga kirish uchun sizda ruxsat mavjud emas."
      icon={<LockOutlined style={{ fontSize: "64px", color: "#fa541c" }} />}
      extra={
        <Button type="primary" onClick={() => navigate("/")}>
          Bosh sahifaga qaytish
        </Button>
      }
    />
  );
};

export default ForbiddenPage;
